module.exports = __webpack_public_path__ + "assets/images/icons/icon_flight.svg?v=c99bfc4f";